<div>
  <dx-popup
    [title]="'Anfrage abschliessen' | translate"
    [showTitle]="true"
    width="350"
    height="250"
    [(visible)]="popupVisible"
    [hideOnOutsideClick]="false"
    [dragEnabled]="false"
    [showCloseButton]="true"
    contentTemplate="popupContent">
    <dxo-position boundaryOffset="0 200" at="top" [of]="'#right-col'" collision="fit"> </dxo-position>
    <div *dxTemplate="let data of 'popupContent'" id="enquiryPopup">
      @if (isLoading) {
        <div id="loadingSpinner">
          <dx-load-indicator id="small-indicator" height="20" width="20"></dx-load-indicator>
        </div>
      } @else {
        <dx-select-box
          [dataSource]="courierVehicles()"
          [(selectedItem)]="selectedCourierVehicle"
          [displayExpr]="'identifier'"
          [valueExpr]="'vehicleId'"></dx-select-box>
        <dx-button [text]="'Wählen'" (onClick)="finishCourierEnquiry()"></dx-button>
      }
    </div>
  </dx-popup>

  <div class="providerSelection-label">{{ 'COURIER.PROVIDER_ENQUERY' | translate }}:</div>
  <div id="providerSelectionContainer">
    <div id="providerSelection">
      <div id="providerSelectionDropdown">
        <dx-tag-box
          [items]="courierSelection"
          [disabled]="!allowUpdating()"
          [(value)]="selectedCouriers"
          [searchEnabled]="true"
          [showSelectionControls]="true"
          [hideSelectedItems]="true"
          displayExpr="Identifier"
          valueExpr="Id"
          [inputAttr]="{ 'aria-label': 'Product' }">
        </dx-tag-box>
      </div>
      <div id="addEnquiryButton">
        <dx-button
          [text]="'BUTTONS.SEND_ENQUIRY' | translate"
          (onClick)="createEnqueries()"
          [disabled]="!allowUpdating()"></dx-button>
      </div>
    </div>
    @if (isLoading) {
      <div id="loadingSpinner">
        <dx-load-indicator id="small-indicator" height="20" width="20"></dx-load-indicator>
      </div>
    }
  </div>
  <dx-text-area
    [placeholder]="'COURIER.ENQUIRY_MESSAGE' | translate"
    [(value)]="enquiryMessage"
    [height]="'100'"
    [disabled]="!allowUpdating()"></dx-text-area>

  <hr />

  <div class="providerSelection-label">{{ 'COURIER.ENQUIRIES' | translate }}:</div>
  <div class="dx-field">
    <!-- Note the template reference variable #grid here -->
    <dx-data-grid
      #grid
      id="courierGrid"
      [dataSource]="courierEnqueries()"
      [wordWrapEnabled]="true"
      [showColumnLines]="false"
      [showRowLines]="true"
      [showBorders]="true"
      [rowAlternationEnabled]="true"
      (onRowUpdating)="updateEnquery($event)"
      width="100%">
      <dxo-editing
        mode="form"
        [allowUpdating]="allowUpdating()"
        [allowDeleting]="false"
        [allowAdding]="false"
        [useIcons]="true"
        (changesChange)="updateOfferDate($event)"
        [(changes)]="changes"
        [allowResourceUpdating]="true">
      </dxo-editing>

      <dxi-column
        [calculateCellValue]="providerWithCityDisplay"
        dataField="Provider.Identifier"
        cssClass="providerColumn"
        [caption]="'COURIER.PROVIDER' | translate"
        [width]="'18%'"
        [allowEditing]="false"
        [allowSorting]="false">
      </dxi-column>

      <dxi-column
        dataField="Enquiry.EnquiryDate"
        dataType="date"
        [caption]="'COURIER.ENQUIRYDATE' | translate"
        [width]="'14%'"
        format="dd.MM.yy HH:mm"
        [allowEditing]="false"
        [allowSorting]="false">
      </dxi-column>

      <dxi-column
        dataField="Enquiry.OfferReceived"
        [caption]="'COURIER.OFFER_RECEIVED' | translate"
        [width]="'14%'"
        [allowSorting]="false">
      </dxi-column>

      <!-- Updated Offer Date column -->
      <dxi-column
        dataField="Enquiry.OfferDate"
        dataType="datetime"
        [caption]="'COURIER.OFFER_DATE' | translate"
        [width]="'16%'"
        format="dd.MM.yy HH:mm"
        [allowSorting]="false">
        <dxo-form-item [colSpan]="1" dataField="Enquiry.OfferDate" itemType="dxDateBox"> </dxo-form-item>
      </dxi-column>

      <dxi-column
        dataField="Enquiry.OfferNetAmount"
        dataType="number"
        [caption]="'COURIER.OFFER_NET_AMOUNT' | translate"
        [width]="'16%'"
        [allowSorting]="false">
        <dxo-format type="currency" [precision]="2"></dxo-format>
      </dxi-column>

      <!-- Empty item for spacing -->
      <dxi-column visible="false" [allowSorting]="false">
        <dxo-form-item [colSpan]="1" itemType="empty"></dxo-form-item>
      </dxi-column>

      <dxi-column
        dataField="Enquiry.Comment"
        dataType="boolean"
        [calculateDisplayValue]="commentDisplay"
        [caption]="'COURIER.COMMENT' | translate"
        [width]="'16%'"
        [allowSorting]="false">
        <dxo-form-item [colSpan]="2" editorType="dxTextArea" [editorOptions]="{ height: 100 }"></dxo-form-item>
      </dxi-column>

      <dxi-column
        dataField="Enquiry.ConfirmationSent"
        [caption]="'COURIER.CONFIRMATION_SENT' | translate"
        [width]="'17%'"
        [allowEditing]="false"
        [allowSorting]="false">
        <dxo-form-item [colSpan]="1" itemType="empty"></dxo-form-item>
      </dxi-column>

      <dxi-column
        dataField="Enquiry.CancellationSent"
        [caption]="'COURIER.CANCELLATION_SENT' | translate"
        [width]="'12%'"
        [allowEditing]="false"
        [allowSorting]="false">
        <dxo-form-item [colSpan]="1" itemType="empty"></dxo-form-item>
      </dxi-column>

      <dxi-column [caption]="'COURIER.CONFIRMMESSAGE' | translate" [visible]="false" [allowSorting]="false">
        <dxo-form-item
          [colSpan]="2"
          editorType="dxTextArea"
          [editorOptions]="{ onValueChanged: setConfirmationMessage, height: 100 }">
        </dxo-form-item>
      </dxi-column>

      <!-- Hidden column for extra items (e.g. the 'reject' button) -->
      <dxi-column [visible]="false" [editCellTemplate]="'formTemplate'"></dxi-column>
      <div *dxTemplate="let data of 'formTemplate'; let index = index" class="">
        <dx-button
          [text]="'BUTTONS.ACCEPT' | translate"
          [disabled]="!data?.data?.Enquiry?.OfferReceived || enquiryBusy.busy()"
          (onClick)="acceptEnquiry(data?.data?.Enquiry?.Id)">
        </dx-button>
      </div>
    </dx-data-grid>
  </div>
</div>
